import WhatsappPost from "../whatsapp/WhatsappPost";

export default function WhatsappChannelView({ channelDetails, isWhiteTheme, customConfig }) {
  return (
    <>
      <WhatsappPost
        channelDetails={channelDetails}
        isWhiteTheme={isWhiteTheme}
        customConfig={customConfig}
      />
    </>
  );
}
